
import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/subscriptions`;
  
export const save = async (formData) => {
  return await apiFetch(
    `${BASE_URL}/`, {
    method: 'POST',
    body: JSON.stringify(formData),
  });
};  
